import useLadyService from '@/services/LadyService';
import { Favicon, Loader } from '@/components/ui';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const RedirectPage = ({ initialData }) => {
	const { t, userCity, navigate, lang, filterState, userType } =
		useLadyService();
	const location = useLocation();

	const pathname = location.pathname;

	const { way } = useParams();

	return (
		<>
			<Favicon />
			{!pathname.includes('404') && !pathname.includes('lk') && (
				<Helmet>
					<link
						rel="canonical"
						href={window.location.href}
					/>
				</Helmet>
			)}
			<div className="ml-auto mt-auto mr-auto">
				<Loader />
			</div>
			<p className="title_h2 text-center mt-36 mb-auto">
				{t('topupbalance')} - {way}
			</p>
		</>
	);
};

export default RedirectPage;
